import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import MiniCard from '../../minicard/minicard';
import ProgressBar from '../../progress-bar/progress-bar';
import { cardIsFinished, donePercentage } from '../../../utils/tcc-utils';
import ListWrapper from './list-wrapper';
import ConfirmationModal from '../../confirmation-modal/confirmation-modal';

export default class MiniCardList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            onConfirm: null,
            masterDate: null,
        };
    }

    tccSubmission = () => {
        this.props.submitTCC(this.props.card.id);
    };

    saveDates = (firstMod, secondMod, masterEnd) => {
        this.props.updateModuleDates(this.props.card.id, firstMod, secondMod, masterEnd);
    };

    changeMasterDate = date => {
        this.setState({ masterDate: date });
    }

    render() {

        const { card, match, links, activities, isSubmitted, tccLoading, firstModEnd, secondModEnd, tccProgresses, classId } = this.props;

        const { tccs = {} } = this.props;
        const { masterDate } = this.state;

        let disableSubmit = false;

        if ( card.id === 'tcc' && (!firstModEnd || !secondModEnd)) {
            disableSubmit = true;
        } else if ( card.id === 'tcc-master' && !masterDate) {
            if ( tccs['tcc-master'] && !tccs['tcc-master'].masterEnd ) {
                disableSubmit = true;
            }
        } else if ( card.id === 'tcc-unificado' && ( !firstModEnd || !secondModEnd || (!masterDate || !tccs['tcc-unificado'].masterEnd ))) {
            if ( firstModEnd && secondModEnd && (!masterDate && !tccs['tcc-unificado'].masterEnd ) ) {
                disableSubmit = true;
            } else if ( !firstModEnd || !secondModEnd ) {
                disableSubmit = true;
            }
        }

        let progress = tccProgresses[`${classId}:${card.id}`];
        if (progress === undefined) {
            progress = donePercentage(card.minicards, activities);
        }

        return (
            <ListWrapper
                {...card} links={links}
            >
                <ModuleDates modifyMasterDate={ this.changeMasterDate } { ...{ firstModEnd, secondModEnd, parentProps: this.props, isSubmitted, onSave: this.saveDates, idClass: card.id } }/>
                <div className='progress-bar'>
                    {!Number.isNaN(progress) && <ProgressBar progress={progress}/>}
                </div>
                {(progress === 100 || isSubmitted) &&
                <div className='submit-wrapper'>
                    <button
                        onClick={() => this.setState({ msg: submissionMsg, onConfirm: this.tccSubmission })}
                        className='submit-button' disabled={isSubmitted || disableSubmit }>
                        {isSubmitted ? 'Submetido' : (tccLoading ? <i style={{ fontSize: '15px' }} className='fa fa-spinner fa-pulse'/> : 'Submeter')}
                    </button>
                </div>}
                <div className='class-resources-wrapper'>
                    <div className='mincards-wrapper flex-horizontal'>
                        {card.minicards
                            .map((card) => (
                                <MiniCard
                                    card={card}
                                    key={card.id}
                                    url={match.url}
                                    finished={cardIsFinished(card, activities)}
                                />
                            ))}
                    </div>
                </div>
                {
                    this.state.onConfirm &&
                    <ConfirmationModal
                        show={true}
                        msg={this.state.msg}
                        onClose={() => this.setState({ onConfirm: null, msg: null })}
                        onConfirm={this.state.onConfirm}
                    />
                }
            </ListWrapper>
        );
    }
}

class ModuleDates extends React.Component {

    state = {
        selectedFirstModEnd: this.props.firstModEnd || null,
        selectedSecondModEnd: this.props.secondModEnd || null,
        selectedMasterModEnd: null,
    };

    componentDidMount() {
        const { parentProps, idClass, firstModEnd, secondModEnd } = this.props;

        if ( idClass !== 'tcc') {
            if ( JSON.stringify(parentProps.tccs) !== '{}') {
                if ( Object.keys(parentProps.tccs).indexOf('tcc-unificado') !== -1 && idClass === 'tcc-unificado' ) {
                    this.setState({
                        selectedFirstModEnd: parentProps.tccs['tcc-unificado'].firstModEnd,
                        selectedSecondModEnd: parentProps.tccs['tcc-unificado'].secondModEnd,
                        selectedMasterModEnd: parentProps.tccs['tcc-unificado'].masterEnd,
                    });
                }
                if ( Object.keys(parentProps.tccs).indexOf('tcc-master') !== -1 && idClass === 'tcc-master' ) {
                    this.setState({
                        selectedFirstModEnd: parentProps.tccs['tcc-master'].firstModEnd,
                        selectedSecondModEnd: parentProps.tccs['tcc-master'].secondModEnd,
                        selectedMasterModEnd: parentProps.tccs['tcc-master'].masterEnd,
                    });
                }
            } else {
                this.setState({
                    selectedFirstModEnd: null,
                    selectedSecondModEnd: null,
                    selectedMasterModEnd: null,
                });
            }
        } else {
            this.setState({
                selectedFirstModEnd: firstModEnd || null,
                selectedSecondModEnd: secondModEnd || null,
                selectedMasterModEnd: null,
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        const { firstModEnd = null, secondModEnd = null, parentProps = {}, idClass } = nextProps;

        if ( idClass === 'tcc') {
            this.setState({
                selectedFirstModEnd: firstModEnd,
                selectedSecondModEnd: secondModEnd,
                selectedMasterModEnd: null,
            });
        } else {
            if ( JSON.stringify(parentProps.tccs) !== '{}') {
                if ( Object.keys(parentProps.tccs).indexOf('tcc-unificado') !== -1 && idClass === 'tcc-unificado' ) {
                    this.setState({
                        selectedFirstModEnd: parentProps.tccs['tcc-unificado'].firstModEnd,
                        selectedSecondModEnd: parentProps.tccs['tcc-unificado'].secondModEnd,
                        selectedMasterModEnd: parentProps.tccs['tcc-unificado'].masterEnd,
                    });
                }

                if ( Object.keys(parentProps.tccs).indexOf('tcc-master') !== -1 && idClass === 'tcc-master' ) {
                    this.setState({
                        selectedFirstModEnd: parentProps.tccs['tcc-master'].firstModEnd,
                        selectedSecondModEnd: parentProps.tccs['tcc-master'].secondModEnd,
                        selectedMasterModEnd: parentProps.tccs['tcc-master'].masterEnd,
                    });
                }
            } else {
                this.setState({
                    selectedFirstModEnd: null,
                    selectedSecondModEnd: null,
                    selectedMasterModEnd: null,
                });
            }
        }

    }

    onSave = () => {
        if (this.hasChange()) {
            const { selectedFirstModEnd, selectedSecondModEnd, selectedMasterModEnd } = this.state;
            if ( typeof this.props.modifyMasterDate === 'function') {
                this.props.modifyMasterDate(selectedMasterModEnd);
            }
            this.props.onSave(selectedFirstModEnd, selectedSecondModEnd, selectedMasterModEnd);
        }
    };

    hasChange = () => {
        const { firstModEnd, secondModEnd, parentProps, idClass } = this.props;
        const { selectedFirstModEnd, selectedSecondModEnd, selectedMasterModEnd } = this.state;
        if ( idClass === 'tcc-unificado') {
            if ( JSON.stringify(parentProps.tccs) !== '{}' && Object.keys(parentProps.tccs).indexOf('tcc-unificado') !== -1 ) {
                return (selectedFirstModEnd !== parentProps.tccs['tcc-unificado'].firstModEnd ) ||
                (selectedSecondModEnd !== parentProps.tccs['tcc-unificado'].secondModEnd ) ||
                ( selectedMasterModEnd !== parentProps.tccs['tcc-unificado'].masterEnd );
            } else {
                return (selectedFirstModEnd !== null ) ||
                (selectedSecondModEnd !== null) ||
                ( selectedMasterModEnd !== null);
            }
        }

        if ( idClass === 'tcc-master' ) {
            if ( JSON.stringify(parentProps.tccs) !== '{}' && Object.keys(parentProps.tccs).indexOf('tcc-master') !== -1 ) {
                return ( selectedMasterModEnd !== parentProps.tccs['tcc-master'].masterEnd );
            } else {
                return ( selectedMasterModEnd !== null );
            }
        }

        if ( idClass === 'tcc' ) {
            return (selectedFirstModEnd !== firstModEnd) || (selectedSecondModEnd !== secondModEnd);
        }

    };

    render() {
        const { isSubmitted, idClass } = this.props;
        const { selectedFirstModEnd, selectedSecondModEnd, selectedMasterModEnd } = this.state;

        const hasChangeData = this.hasChange();

        return (
            <div className='expiration'>
                <div className='inputs-container'>
                    { (idClass === 'tcc-unificado' || idClass === 'tcc') &&
                        <React.Fragment>
                            <div className={`input-wrapper date-select ${ idClass === 'tcc-unificado' || idClass === 'online-test' ? 'triple-inputs' : ''}`}>
                                <label>Conclusão 1º módulo em formação:</label>
                                <DatePicker
                                    readOnly
                                    disabled={!!isSubmitted}
                                    selected={selectedFirstModEnd ? moment(selectedFirstModEnd) : null }
                                    name='firstModule'
                                    id='firstModule'
                                    onChange={(date) => this.setState({ selectedFirstModEnd: date.toISOString() })}/>
                            </div>
                            <div className={`input-wrapper date-select ${ idClass === 'tcc-unificado' ? 'triple-inputs' : ''}`}>
                                <label>Conclusão 2º módulo em formação:</label>
                                <DatePicker
                                    readOnly
                                    disabled={!!isSubmitted}
                                    selected={selectedSecondModEnd ? moment(selectedSecondModEnd) : null}
                                    name='secondModule'
                                    id='secondModule'
                                    onChange={(date) => this.setState({ selectedSecondModEnd: date.toISOString() })}/>
                            </div>
                        </React.Fragment>
                    }
                    { (idClass === 'tcc-unificado' || idClass === 'tcc-master') &&
                        <div className={`input-wrapper date-select master ${ idClass === 'tcc-unificado' ? 'triple-inputs' : ''}`}>
                            <label>Conclusão em Master:</label>
                            <DatePicker
                                readOnly
                                disabled={!!isSubmitted}
                                selected={selectedMasterModEnd ? moment(selectedMasterModEnd) : null}
                                name='masterModule'
                                id='masterModule'
                                onChange={ (date) => this.setState({ selectedMasterModEnd: date.toISOString() }) }/>
                        </div>
                    }
                </div>
                <button
                    className='submit-button'
                    disabled={!hasChangeData}
                    onClick={this.onSave}
                >Salvar datas</button>
            </div>
        );
    }
}

const submissionMsg = `A submissão só pode ser realizada uma vez e revisões posteriores a ela só serão possíveis via
    e-mail com o responsável pedagógico. Deseja continuar com a submissão?`;



// WEBPACK FOOTER //
// ./src/components/section/components/minicard-list.js